import { takeLatest, call, put } from 'redux-saga/effects';
import { postPatientLifeStyleSuccess, postPatientLifeStyleFailure, putPatientLifeStyleSuccess, putPatientLifeStyleFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
function* postPatientLifeStyleRequest(action) {
    try {
const response = yield call(apiPost, 'api/post-patient-lifeStyle', action.payload);
        yield put(postPatientLifeStyleSuccess(response));
    } catch (error) {
        yield put(postPatientLifeStyleFailure(error?.response?.message || error));
    }
}


function* putPatientLifeStyleRequest(action) {
    try {
const response = yield call(apiPut, `api/edit-patient-lifeStyle/${action.payload._id}`, action.payload);
        yield put(putPatientLifeStyleSuccess(response));
    } catch (error) {
        yield put(putPatientLifeStyleFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientLifeStyle/postPatientLifeStyleRequest', postPatientLifeStyleRequest);
    yield takeLatest('patientLifeStyle/putPatientLifeStyleRequest', putPatientLifeStyleRequest);
}

export default saga;